export default {
   init() {
      const modal = document.querySelector('.enquire-modal');

      if (!modal) return;

      const content = modal.querySelector('.enquire-modal__content');
      const closeBtn = modal.querySelector('.enquire-modal__close');
      const formInner = modal.querySelector('.enquire-modal__form-inner');

      function openModal(formId) {
         modal.classList.add('is-open');
         document.body.classList.add('enquire-modal-open');
         loadForm(formId);
      }

      function closeModal() {
         modal.classList.remove('is-open');
         document.body.classList.remove('enquire-modal-open');
      }

      function loadForm(formId) {
         formInner.innerHTML = '<div class="enquire-modal__loading" style="color: #0B0F0C;">Loading...</div>';

         fetch(block_script.ajax_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
               action: 'get_enquiry_form',
               form_id: formId,
               nonce: block_script.nonce,
            })
         })
            .then(res => res.json())
            .then(data => {
               if (data.success) {
                  formInner.innerHTML = data.data;

                  // Re-execute scripts trong response
                  formInner.querySelectorAll('script').forEach(oldScript => {
                     const newScript = document.createElement('script');
                     [...oldScript.attributes].forEach(attr =>
                        newScript.setAttribute(attr.name, attr.value)
                     );
                     newScript.textContent = oldScript.textContent;
                     oldScript.parentNode.replaceChild(newScript, oldScript);
                  });

                  // Reset GF submitting flag
                  if (window[`gf_submitting_${formId}`]) {
                     window[`gf_submitting_${formId}`] = false;
                  }

                  // Trigger GF init nếu có
                  if (window.jQuery) {
                     jQuery(document).trigger('gform_post_render', [formId, 1]);
                  }

               } else {
                  formInner.innerHTML = '<p style="color: #0B0F0C;">Form not found.</p>';
               }
            })
            .catch(() => {
               formInner.innerHTML = '<p style="color: #0B0F0C;">Something went wrong.</p>';
            });
      }

      // Open (delegated so it also works for cards injected later, e.g. via "Load more")
      document.addEventListener('click', function (e) {
         const trigger = e.target.closest('[data-enquire-modal]');
         if (!trigger) return;

         e.preventDefault();
         const formId = trigger.dataset.formId;
         openModal(formId);
      });

      // Click outside content
      modal.addEventListener('click', function (e) {
         if (!content.contains(e.target)) closeModal();
      });

      // Close button
      if (closeBtn) closeBtn.addEventListener('click', closeModal);

      // ESC
      document.addEventListener('keydown', function (e) {
         if (e.key === 'Escape') closeModal();
      });
   }
}